<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color: #101129 !important;">
      <div class="display-content" v-if="toReload" style="position:relative">
        <div
          style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 35px;
                left: 0;
              "
        >
              <span @click="toggleApi" style="margin-right:2rem">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
          <span @click="goback">
                <span class="fullscreen-btn">返回首页</span>
              </span>
        </div>
        <div
          style="
                width: 98%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 85px;
                left: 25px;
              "
        >
          <button class="cool-button-active">综合数据</button>
          <button class="cool-button" @click="goSchool" >体教融合</button>
          <button class="cool-button" @click="goOrgan" >组织架构</button>
          <button class="cool-button" @click="goSite" >基础设施</button>
          <button class="cool-button" @click="goKeyCity">重点城市</button>
        </div>
        <!--左半边-->
        <div class="column left">
          <!--精英机构数量-->
          <div class="row class-all">
            <div class="com-wrapper">
              <statistical-com
                :numStatistical="propsNumStatistical"
              ></statistical-com>
            </div>
          </div>

          <!--球队饼状图-->
          <div class="row class-all">
            <div class="pie-wrapper">
              <template v-if="isShowChild">
                <pie-com
                  :propsReloadTime="reloadTime"
                  :statisticsSquadLevel = "statisticsSquadLevelVos"
                  :statisticsSquadAllNum = "statisticsSquadAllNum"
                ></pie-com>
              </template>
            </div>
          </div>

          <!--教练柱状图-->
          <div class="row class-all">
            <div class="login-wrapper">
              <template v-if="isShowChild">
                <teacher-com
                  :propsCoachList="propsCoachList"
                ></teacher-com>
              </template>
            </div>
          </div>
        </div>
        <!--中间-->
        <div class="column center">
          <!--地图-->
          <div class="map-canvas">
            <div class="map-title">
              <!-- {{ year }}年各省/自治区/直辖市/特别行政区开班数量 -->
              精英机构分布
            </div>
            <div class="echart-map-wrapper">
              <template v-if="isShowChild">
                <map-com
                  :statisticsToCounty="statisticsToCounty"
                  :domName="mapName"
                  :propsReloadTime="reloadTime"
                  :youthMap="youthMap"
                ></map-com>
              </template>
            </div>
          </div>

          <!--球员数据-->
          <div class="row class-all">
            <div class="line-wrapper">
              <template v-if="isShowChild">
                <line-com
                  :userCount="propsUserCount"
                  :playerNum="playerNum"
                  :playerNumAll="playerNumAll"
                  :playerNumAllNan="playerNumAllNan"
                  :playerNumAllNv="playerNumAllNv"
                  :playerKey="playerKey"
                  :type="type"
                ></line-com>
              </template>
            </div>
          </div>
        </div>
        <!--右半边-->
        <div class="column right">
          <!--训练计划数量-->
          <div class="row class-all">
            <div class="toturial-wrapper">
              <toturial-com
                :propsStatisticsPlan="statisticsPlanVo"
              ></toturial-com>
            </div>
          </div>

          <!--训练计划滚动表-->
          <div class="row class-all">
            <div class="h290">
              <waterFall-com
                :propsReloadTime="reloadTime"
              ></waterFall-com>
            </div>
          </div>

          <!--教案库折线图-->
          <div class="row class-all">
            <div class="grade-wrapper">
              <template v-if="isShowChild">
                <tutorial-line-com
                  :trainingAllNum="trainingAllNum"
                  :trainingNum="trainingNum"
                  :trainingMonth="trainingMonth"
                ></tutorial-line-com>
              </template>
            </div>
          </div>
        </div>
      </div>

    </fullscreen>
  </div>
</template>

<script>
  import VueFullscreen from "vue-fullscreen";
  import Vue from "vue";
  import  statistics  from "@/api/statistics";
  Vue.use(VueFullscreen);

  export default {
    data() {
      return {
        fullscreen: false,
        isFullscreen: false,
        toReload: true,
        mapName: "echartsTestProvince",
        mapProvinceName: "上海",
        isShowChild: true,
        statisticsSquadLevelVos:{},// 球队饼状图
        statisticsSquadAllNum:0,// 球队总数量
        playerNumAllNan: 0, // 球员总数量
        playerNumAllNv: 0, // 球员总数量
        statisticsPlanVo:{},// 精英机构训练周、日训练计划数量
        statisticsToCounty:{},// 精英机构分布区县
        youthMap:{},// 精英机构分布区县
        propsUserCount: {
          // 显示球员数量的，暂时不需要
          userInfoCount: 0,
          userInfoCountMonth: 0,
          userInfoCountDay: 0,
        },
        playerNum: [], // 球员数量
        playerKey: [], // 球员所在机构简称
        trainingAllNum: 0, // 教案总数量
        playerNumAll: 0, // 球员总数量
        trainingNum: [], // 教案数量
        trainingMonth: [], // 教案月份
        propsNumStatistical: {},  // 精英机构数量，暂时写死了
        propsCoachList: [], //教练柱状图
        reloadTime: 30000,  // ms
        type: 'allYouth',  // ms
      };
    },

    components:{
      "statistical-com": () => import("./components/YouthStatistical"), // 精英机构数量统计
      "pie-com": () => import("./components/SquadStatistics"), // 球队统计
      "teacher-com": () => import("./components/CoachStatistics"), // 教练统计
      "map-com": () => import("./EchartsProvince"), // 地图
      "line-com": () => import("./components/PlayerStatistics"), // 球员统计
      "toturial-com": () => import("./components/PlanStatistical"), // 训练计划数量
      "waterFall-com": () => import("./components/PlanData"), // 训练计划滚动
      "tutorial-line-com": () => import("./components/TeachingStatistics"), // 教案库统计
    },

    computed: {
//      year() {
//        let year = new Date().getFullYear();
//        return year; // 如果有需求，返回当前年份，非固定
//      },
    },

    mounted() {
      this.isShowChild = false;
      this.loadInfo();
      document.getElementsByTagName('html')[0].style.fontSize = '11px';
    },

    destroyed() {
      document.getElementsByTagName('html')[0].style.fontSize = '10.672358591248667vh';
    },


    methods: {
      toggleApi() {
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
          teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback: (isFullscreen) => {
            that.fullscreen = isFullscreen;
          },
        });
      },
      goSchool(){
        this.$router.push({
          path: '/statisticsSchool',
        })
      },
      goSite(){
        this.$router.push({
          path: '/statisticsSiteFacilities',
        })
      },
      goKeyCity(){
        this.$router.push({
          path: '/statisticsKeyCityTrain',
        })
      },
      goOrgan(){
        this.$router.push({
          path: '/statisticsOrganizational',
        })
      },
      goback(){
        this.$router.push({
          path: '/',
        })
      },

      loadInfo() {
        statistics.getStatistics()
        .then(res => {
          const {
            statisticsCoachVos,  // 教练数量
            statisticsPlayerVos,  // 球员数量
            statisticsSquadAllNum,  // 精英机构的球队总数量
            statisticsSquadLevelVos,  // 球队饼状图
            statisticsTrainingVos,  // 教案折线图
            statisticsTrainingAllNum,  // 教案总数量
            statisticsPlanVo,  // 精英机构训练周、日训练计划数量
            statisticsToCounty,  // 精英机构分布区县
            statisticsPlayerNums,
            statisticsPlayerNumsNan,
            statisticsPlayerNumsNv,
            youthMap
          } = res;

          // region 球队饼状图
          this.statisticsSquadLevelVos = statisticsSquadLevelVos;
          this.statisticsSquadAllNum = statisticsSquadAllNum;
          // endregion

          // region 教练柱状图
          let defaultStatisticsCoachVos = [0,0,0,0,0,0,0];
          statisticsCoachVos.forEach(item => {
            if(item.classLevel === '0') defaultStatisticsCoachVos[0] = item.num;
            if(item.classLevel === 'A') defaultStatisticsCoachVos[1] = item.num;
            if(item.classLevel === 'B') defaultStatisticsCoachVos[2] = item.num;
            if(item.classLevel === 'C') defaultStatisticsCoachVos[3] = item.num;
            if(item.classLevel === 'D') defaultStatisticsCoachVos[4] = item.num;
            if(item.classLevel === 'E') defaultStatisticsCoachVos[5] = item.num;
            if(item.classLevel === '1'){
              defaultStatisticsCoachVos[6] = defaultStatisticsCoachVos[6] + item.num;
            }
            if(!item.classLevel){
              defaultStatisticsCoachVos[6] = defaultStatisticsCoachVos[6] + item.num;
            }
          });
          this.propsCoachList = defaultStatisticsCoachVos;
          // endregion

          // region 球员柱状图
//          let playerNum = [356,415,221,132,231,259,165,123,147,159,164,241,211,312,154,366]; // 测试球员数据数量
          let playerNum = []; // 球员数量
          let playerKey = []; // 球员所在机构简称
          if(statisticsPlayerVos && statisticsPlayerVos.length) {
            statisticsPlayerVos.forEach((item,index) => {
              playerNum[index] = item.num;
              playerKey[index] = item.playerKey;
            });
          }
          this.playerNum = playerNum;
          this.playerNumAll = statisticsPlayerNums;
          this.playerNumAllNan = statisticsPlayerNumsNan;
          this.playerNumAllNv = statisticsPlayerNumsNv;
          this.playerKey = playerKey;
          // endregion


          // region 教案折线图
          //          let TrainingMonth = ['2021-11','2021-12','2022-01','2022-02','2022-03','2022-04','2022-05','2022-06','2022-07','2022-08','2022-09','2022-10']; // 教案月份
//          let TrainingNum = [32,123,233,432,321,123,231,421,512,325,367,299]; // 测试教案数量
          let TrainingNum = [0,0,0,0,0,0,0,0,0,0,0,0]; // 教案数量
          let TrainingMonth = []; // 教案月份
          let num = 0;
          let data = new Date();  // 获取当前时间
          data.setMonth(data.getMonth(), 1); //获取到当前月份,设置月份
          for (let i = 0; i < 12; i++) {
            data.setMonth(data.getMonth() - 1);//每次循环一次 月份值减1
            let m = data.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            TrainingMonth.unshift(data.getFullYear() + "-" + (m))
          }
          if(statisticsTrainingVos && statisticsTrainingVos.length) {
            statisticsTrainingVos.forEach(item => {
              num = item.num + num;
              TrainingMonth.forEach((item1,index1) => {
                if(item1 === item.month){
                  TrainingNum[index1] = item.num;
                  TrainingMonth[index1] = item.month;
                }
              });
            });
          }
          this.trainingNum = TrainingNum;
//          this.trainingAllNum = 3419;
          this.trainingAllNum = statisticsTrainingAllNum;
//          this.trainingAllNum = num;
          this.trainingMonth = TrainingMonth;
          // endregion

          // region 精英机构训练周、日训练计划数量
          this.statisticsPlanVo = statisticsPlanVo;
          // endregion

          // region 精英机构分布区县
          this.statisticsToCounty = statisticsToCounty;
          this.youthMap = youthMap;
          // endregion


          this.isShowChild = true; // 开始画图
        })
        .catch((err) => {
          console.error("err", err);
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'
  .display-wrapper
    width 100%
    height 100%
    font-size 12px !important
    background-color #101129 !important
  .display-content
    font-size 12px !important
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    min-height 780px
    margin 0 auto
    display flex
    padding 9rem 0.8rem 0
    background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
    .cool-button
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #60c5e9, #2a4d6a);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .cool-button:hover
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      transform: skew(-15deg) translateY(-2px); /* 保持倾斜并提升按钮位置 */
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    .cool-button-active
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .column
      position relative
      flex 3
      .row
        box-sizing border-box
        border 2px solid red
        border-image url('../../assets/images/display/border.png') 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 5rem
        color #FFFFFF
      .row-content
        position absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem 2rem
      .class-all
        min-height 110px
        .row-title
          color #68d8fe
          font-weight 600
          font-size 16px
          margin-bottom 0.4rem
          display flex
          align-items center
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 0.8rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          .btn-active
            background-color #0bace6
            color #FFFFFF
        .data-wrapper
          display flex
          flex-wrap wrap
          .data-item
            flex 1
            font-size 12px
            text-align center
            .data
              font-size 26px
            .data-title
              color #4c9bfd
              margin-top 5px
      .class-table
        height 350px
        .row-content
          padding 1.25rem 0
        .nav-title-wrapper
          padding-left 1.25rem
          margin-bottom 0.8rem
          .nav-item
            margin-right 15px
            cursor pointer
            color #1950c4
            padding-right 15px
            border-right 2px solid #00f2f1
            &:last-child
              border-right none
          .active-title
            color #FFFFFF
        .table-wrapper
          .table-head
            display flex
            width 100%
            background-color rgba(255, 255, 255, 0.1)
            color #68d8fe
            padding 0 1rem
            line-height 3rem
            .table-column
              /* flex 1 */
              text-align center
              &:nth-child(1)
                width 20%
              &:nth-child(2)
                width 30%
              &:nth-child(3)
                width 20%
              &:nth-child(4)
                width 15%
              &:nth-child(5)
                width 15%
          .table-content
            height 250px
            overflow hidden
            .table-row
              width 100%
              display flex
              padding 0 1rem
              line-height 2.5rem
              color #61a8ff
              &:hover
                background-color rgba(255, 255, 255, 0.1)
                color #68d8fe
              .table-col
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                text-align center
                &:nth-child(1)
                  width 20%
                &:nth-child(2)
                  width 30%
                &:nth-child(3)
                  width 20%
                &:nth-child(4)
                  width 15%
                &:nth-child(5)
                  width 15%
    .center
      flex 4
      margin 3.8rem 1.5rem 0
      .map-title
        color #68d8fe
        font-size 1.6rem
        text-align center
      .echart-map
        width 100%
        /* height 440px + 4.875rem */
        height 455px
      .online
        position absolute
        top -18px
        left 0
        z-index 999
        .online-content
          width inherit
          height inherit
          position absolute
          top -40px
          left -56px
          display flex
          flex-direction column
          .title
            width 100%
            color #68d8fe
            font-size 1.6rem
            line-height 4rem
            text-align center
          .content
            flex 1
            font-size 2.4rem
            display flex
            justify-content center
            align-items center
  .table-content
    .animation-wrapper
      animation row 20s linear infinite
      &:hover
        animation-play-state paused
  .tutorial-add
    height 350px !important
    .data-wrapper
      height 90%
    .echart-tutorial-add
      width 100%
      height 100%
  .login-data
    height 340px !important
    .data-wrapper
      height 90%
    .echart-user-login
      width 100%
      height 100%
  .class-vip
    height 340px !important
    .data-wrapper
      height 90%
    .echart-class-status
      width 100%
      height 100%
  .user-all
    height 340px !important
    margin-top 4.6rem
    .flex-box
      display flex
      width 100%
      height 100%
      .flex-item
        /* flex 1 1 */
        height 100%
        .data-wrapper
          height 90%
      .left
        flex 5
      .right
        flex 2
        padding 8rem 2rem 8rem 2rem
        display flex
        flex-direction column
        justify-content space-around
        font-size 1.4rem
        color #61a8ff
        text-align center
        .line-text
          /* text-align left */
          display flex
          justify-content space-between
          span:nth-child(1)
            display flex
            align-items center
            justify-content flex-start
          span:nth-child(2)
            font-size 2.5rem
            margin-left 5px
            color #FFFFFF
            text-align left
            display block
            width 6rem
    .echart-associate-all
      width 100%
      height 100%
  @keyframes row
    0%, 100%
      transform translateY(-50%)
  .fullscreen-btn
    color #61a8ff
    cursor pointer
</style>

<style lang="stylus" scoped>
  .h290
    height 290px
  .echart-map-wrapper
    height 500px
    box-sizing border-box
    padding-bottom 42px
  .pie-wrapper
    // height 250px
    height 290px
    width 100%
  .line-wrapper
    // height 250px
    height 290px
  .grade-wrapper
    height 290px
  .login-wrapper
    // height 250px
    height 290px
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0b93d5
      color #68d8fe
  /* .el-select-dropdown */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  /* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
</style>
